import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'fish',
      d: 'M0,-2.5h2v0.5h-2zM-0.5,-2h2.5v0.5h-2.5zM-2,-1.5h2v0.5h-2zM-2.5,-1h2.5v0.5h-2.5zM0,0h2.5v1h-2.5z',
    },
  ],
  pixels: 28,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
